// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FULLY_VISIBLE } from '@tcp/core/src/constants/rum.constants';
import RenderPerf from '@tcp/web/src/components/common/molecules/RenderPerf';
import { PRODUCT_ADD_TO_BAG } from '@tcp/core/src/constants/reducer.constants';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary/errorBoundary';
import ProductRating from '@tcp/core/src/components/features/browse/ProductDetail/molecules/ProductRating/ProductRating';
import { isCanada, getCurrentPOD } from '@tcp/core/src/utils/utils';
import Promotions from '@tcp/core/src/components/common/organisms/Promotions';
import ProductPrice from '../../ProductPrice/ProductPrice';
import PlccWrapperStatic from '../../PlccWrapperStatic/views/PlccWrapperStatic.view';
import ProductBasicInfo from '../../ProductBasicInfo/ProductBasicInfo';

import {
  getPrices,
  getPricesWithRange,
  getMapSliceForColorProductId,
  checkIsSelectedSizeDisabled,
  getMapSliceForSizeSkuID,
  getPriceWhenAccessoriesPresent,
  getBrandName,
} from '../../../../ProductListing/molecules/ProductList/utils/productsCommonUtils';

const getColorname = (colorProduct) =>
  (colorProduct.color && colorProduct.color.family) || colorProduct?.color?.name;

const getBadgePercentage = (colorProduct) =>
  colorProduct.miscInfo && colorProduct.miscInfo.badge2 ? colorProduct.miscInfo.badge2 : '';

/* eslint-disable-next-line complexity, sonarjs/cognitive-complexity */
const Product = (props) => {
  const {
    productDetails,
    setProductDataForReviewActn,
    isNewPDPEnabled,
    socialProofMessage,
    primaryBrand,
    alternateBrand,
    handleRatingClick,
    selectedColorProductId,
    isNewPJPPDPRedesignEnabled,
    setPdpTabSectionName,
    productMiscInfo,
  } = props;
  const { currentProduct: productInfo } = productDetails || {};

  if (!productInfo) {
    return <div />;
  }

  const colorProduct =
    getMapSliceForColorProductId(productInfo.colorFitsSizesMap, selectedColorProductId) || {};

  /**
   * This just holds the logic for rendering a UX timer
   * to measure when the cart items appear. It reads the
   * number of cart items and renders the timer if that
   * number is greater than zero.
   */
  function ProductInfoUXTimer({ productObj }) {
    const [state, setState] = useState(false);
    useEffect(() => {
      if (productObj.name) setState(true);
    }, [productObj.name]);
    return state ? <RenderPerf.Measure name={FULLY_VISIBLE} /> : null;
  }

  const renderProductRatings = useCallback(
    (
      _,
      isNewQVEnabled,
      __,
      ___,
      ____,
      isPDPRedesignEnablednew,
      setPdpTabSectionIndex,
      handleAddRemoveFromWishlistObj,
      outFitFavt
    ) => {
      const {
        ratingsProductId,
        name,
        ratings = 0,
        reviewsCount,
        unbxdRatings = 0,
        unbxdReviewsCount,
      } = productInfo;
      const { favoritedCount } = productMiscInfo || {};
      return (
        Number(ratings) >= 0 && (
          <ProductRating
            ratings={ratings || unbxdRatings || 0}
            reviews={reviewsCount || unbxdReviewsCount}
            isNewQVEnabled={isNewQVEnabled}
            isNewPDPEnabled={isNewPDPEnabled}
            socialProofMessage={socialProofMessage}
            pageName="PDP"
            handleRatingClick={handleRatingClick}
            ratingsProductId={ratingsProductId}
            setProductDataForReviewActn={setProductDataForReviewActn}
            primaryBrand={primaryBrand || alternateBrand}
            productName={name}
            colorDisplayId={colorProduct?.colorDisplayId}
            isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
            setPdpTabSectionName={setPdpTabSectionName}
            isPDPRedesignEnabled={isPDPRedesignEnablednew}
            favoritedCount={favoritedCount}
            setPdpTabSectionIndex={setPdpTabSectionIndex}
            handleAddRemoveFromWishlistObj={handleAddRemoveFromWishlistObj}
            outFitFavt={outFitFavt}
          />
        )
      );
    },
    [productDetails, productMiscInfo]
  );
  const {
    currencySymbol,
    priceCurrency,
    currencyAttributes,
    isHasPlcc,
    isInternationalShipping,
    isMatchingFamily,
    isGiftCard,
    onAddItemToFavorites,
    isLoggedIn,
    isShowPriceRangeKillSwitch,
    formValues = {},
    isBundleProduct,
    keepAlive,
    reviewOnTop,
    AddToFavoriteErrorMsg,
    removeAddToFavoritesErrorMsg,
    hideItemProp,
    isInWishList,
    showPriceRangeForABTest,
    resetCountUpdate,
    countUpdated,
    hidePriceDisplay,
    selectedMultipack,
    isPerUnitPriceEnabled,
    isStyleWith,
    checkForOOSForVariant,
    isBrierleyPromoEnabled,
    TCPStyleQTY,
    onSetLastDeletedItemIdAction,
    wishList,
    deleteFavItemInProgressFlag,
    isAfterPayDisplay,
    isOutfitPage,
    errorMessages,
    isShowBrandNameEnabled,
    openModal,
    priceInfoAccessoryPresent,
    isAccessoryPresentMandatory,
    accessories,
    secondarySelectedAccessoryList,
    isHideOriginalPrice,
    isPlccPriceOnPDP,
    isPDPRedesignEnabled,
    shouldRenderPriceOnly,
    zoneOneBadges,
    setPdpTabSectionIndex,
    isShowPromoPriceMicroData,
    setPromotionPrice,
    promotionPrice,
    isPDP,
    plccOfferPercentage,
    isUpdatedPromotionsDisplayEnabled,
    isStoreSpecialsPriceOn,
    storeSpecialDiscount,
    isPickupSelectedAtProductDetail,
    storeSpecials,
    promoPriceForStoreSpecial,
    activePromotions,
    defaultStoreId,
    storeSpecialList,
    isShowNonH1Title,
    storeSpecialV2Enabled,
    isClickableBrandBadgesEnabled,
  } = props;
  const { fit, size } = formValues;
  const { TCPMultipackProductMapping, TCPStyleType } = productInfo || {};
  const { promotionalMessage, promotionalPLCCMessage } = productInfo;
  let prices = getPrices(productInfo, colorProduct.color && colorProduct.color.name, fit, size);
  const badges = colorProduct.miscInfo ? colorProduct.miscInfo.badge1 : {};
  const badge1 = isMatchingFamily && badges.matchBadge ? badges.matchBadge : badges.defaultBadge;
  const badge2 = getBadgePercentage(colorProduct);

  const storeSpecialInCurrentStore = storeSpecialV2Enabled
    ? !!storeSpecialList?.[defaultStoreId]
    : true;
  let skuId = null;
  if (typeof size === 'string' && size) {
    skuId = getMapSliceForSizeSkuID(colorProduct, size);
  }
  const colorProductName = getColorname(colorProduct);

  if (isShowPriceRangeKillSwitch && !isAccessoryPresentMandatory) {
    const isSelectedSizeDisabled = checkIsSelectedSizeDisabled(productInfo, formValues);
    prices = getPricesWithRange(productInfo, colorProductName, fit, size, isSelectedSizeDisabled);
  }

  if (!showPriceRangeForABTest) {
    prices = {
      listPrice: prices.listPrice,
      offerPrice: prices.offerPrice,
      badge2: prices.badge2,
    };
  }

  if (isBundleProduct) {
    prices = getPricesWithRange(productInfo, colorProductName);
  }

  // checking if accessory are present and it is mandatory to select then we have to show price
  prices = {
    ...getPriceWhenAccessoriesPresent(
      prices,
      accessories,
      priceInfoAccessoryPresent,
      isAccessoryPresentMandatory,
      secondarySelectedAccessoryList
    ),
  };

  const { TCPPromotionID, TCPPromotionPrice, minStorePrice, maxStorePrice, storeId } =
    colorProduct || {};
  const storeSpecialPriceRange = { minStorePrice, maxStorePrice, storeId };

  return (
    <>
      {!shouldRenderPriceOnly && (
        <div
          className={
            isPDPRedesignEnabled
              ? ''
              : (!reviewOnTop && 'hide-on-mobile') ||
                (reviewOnTop && 'hide-on-desktop hide-on-tablet')
          }
        >
          <ProductBasicInfo
            keepAlive={keepAlive}
            badge={badge1}
            isGiftCard={isGiftCard}
            productInfo={productInfo}
            isShowFavoriteCount
            currencySymbol={currencySymbol}
            priceCurrency={priceCurrency}
            currencyAttributes={currencyAttributes}
            isRatingsVisible
            isCanada={isCanada()}
            isPlcc={isHasPlcc}
            isBundleProduct={isBundleProduct}
            isInternationalShipping={isInternationalShipping}
            onAddItemToFavorites={onAddItemToFavorites}
            isLoggedIn={isLoggedIn}
            productMiscInfo={colorProduct}
            AddToFavoriteErrorMsg={AddToFavoriteErrorMsg}
            removeAddToFavoritesErrorMsg={removeAddToFavoritesErrorMsg}
            pageName="PDP"
            skuId={skuId}
            formName={PRODUCT_ADD_TO_BAG}
            reviewOnTop={reviewOnTop}
            isInWishList={isInWishList}
            hideRating={isBundleProduct}
            resetCountUpdate={resetCountUpdate}
            socialProofMessage={socialProofMessage}
            countUpdated={countUpdated}
            isStyleWith={isStyleWith}
            checkForOOSForVariant={checkForOOSForVariant}
            onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
            wishList={wishList}
            deleteFavItemInProgressFlag={deleteFavItemInProgressFlag}
            isOutfitPage={isOutfitPage}
            errorMessages={errorMessages}
            isNewPDPEnabled={isNewPDPEnabled}
            primaryBrand={primaryBrand || alternateBrand}
            colorProductName={colorProductName}
            isShowBrandNameEnabled={isShowBrandNameEnabled}
            renderProductRatings={renderProductRatings}
            formValues={formValues}
            alternateBrand={alternateBrand}
            setProductDataForReviewActn={setProductDataForReviewActn}
            isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
            setPdpTabSectionName={setPdpTabSectionName}
            isPDPRedesignEnabled={isPDPRedesignEnabled}
            zoneOneBadges={zoneOneBadges}
            setPdpTabSectionIndex={setPdpTabSectionIndex}
            shouldRenderH1Title={isPDP || isBundleProduct}
            isShowNonH1Title={isShowNonH1Title}
            isClickableBrandBadgesEnabled={isClickableBrandBadgesEnabled}
          />
        </div>
      )}
      {(!isPDPRedesignEnabled || shouldRenderPriceOnly) && (
        <div
          className={`${reviewOnTop ? 'hide-on-mobile hide-on-desktop hide-on-tablet' : ''}${
            shouldRenderPriceOnly && !isGiftCard ? 'pdp-redesign-price-and-promo-wrapper' : ''
          }`}
        >
          {!isGiftCard && !hidePriceDisplay && (
            <>
              <ProductPrice
                hideItemProp={hideItemProp}
                currencyAttributes={currencyAttributes}
                isItemPartNumberVisible={false}
                itemPartNumber={colorProduct.colorDisplayId}
                {...prices}
                badge2={badge2}
                promotionalMessage={promotionalMessage}
                isCanada={isCanada()}
                promotionalPLCCMessage={promotionalPLCCMessage}
                isPlcc={isHasPlcc}
                isInternationalShipping={isInternationalShipping}
                selectedMultipack={selectedMultipack}
                TCPMultipackProductMapping={TCPMultipackProductMapping}
                TCPStyleType={TCPStyleType}
                isPerUnitPriceEnabled={isPerUnitPriceEnabled}
                isStyleWith={isStyleWith}
                isGiftCard={isGiftCard}
                productInfo={productInfo}
                isBrierleyPromoEnabled={isBrierleyPromoEnabled}
                TCPStyleQTY={TCPStyleQTY}
                deleteFavItemInProgressFlag={deleteFavItemInProgressFlag}
                wishList={wishList}
                isAfterPayDisplay={isAfterPayDisplay}
                isInWishList={isInWishList}
                isOutfitPage={isOutfitPage}
                errorMessages={errorMessages}
                isNewPDPEnabled={isNewPDPEnabled}
                renderProductRatings={renderProductRatings}
                primaryBrand={primaryBrand || alternateBrand}
                alternateBrand={alternateBrand}
                isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
                preOrderDate={getCurrentPOD(colorProduct, formValues)}
                isHideOriginalPrice={isHideOriginalPrice}
                colorProductId={colorProduct?.colorProductId}
                isPDPRedesignEnabled={isPDPRedesignEnabled}
                isPDPRedesignPrice={shouldRenderPriceOnly}
                setPromotionPrice={setPromotionPrice}
                promotionPrice={promotionPrice}
                isShowPromoPriceMicroData={isShowPromoPriceMicroData}
                TCPPromotionPrice={TCPPromotionPrice}
                TCPPromotionID={TCPPromotionID}
                isUpdatedPromotionsDisplayEnabled={isUpdatedPromotionsDisplayEnabled}
                isStoreSpecialsPriceOn={isStoreSpecialsPriceOn}
                storeSpecialDiscount={storeSpecialDiscount}
                isPickupSelectedAtProductDetail={isPickupSelectedAtProductDetail}
                storeSpecials={storeSpecials}
                activePromotions={activePromotions}
                storeSpecialPriceRange={storeSpecialPriceRange}
                defaultStoreId={defaultStoreId}
                storeSpecialInCurrentStore={storeSpecialInCurrentStore}
              />
              <ProductInfoUXTimer productObj={productInfo} />
              {TCPPromotionID && (
                <Promotions
                  underLine
                  showArrow
                  showIcon={false}
                  showHeading
                  className={`isPDP ${
                    shouldRenderPriceOnly ? 'pdp-redesign-promo-wrapper' : 'hide-on-mobile'
                  }`}
                  isStyleWith={isStyleWith}
                  pageName="PDP"
                  brand={getBrandName(primaryBrand, alternateBrand)}
                  isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
                  isPDPRedesignPromo={{ shouldRenderPriceOnly }}
                  setPromotionPrice={setPromotionPrice}
                  isShowPromoPriceMicroData={isShowPromoPriceMicroData}
                  TCPPromotionPrice={TCPPromotionPrice}
                  TCPPromotionID={TCPPromotionID}
                  isUpdatedPromotionsDisplayEnabled={isUpdatedPromotionsDisplayEnabled}
                  TCPPromotionPriceStoreSpecial={promoPriceForStoreSpecial}
                  isPickupSelectedAtProductDetail={isPickupSelectedAtProductDetail}
                  storeSpecials={storeSpecials}
                />
              )}
              {!isCanada() &&
                !isHasPlcc &&
                !isBundleProduct &&
                !shouldRenderPriceOnly &&
                !isPDPRedesignEnabled && (
                  <PlccWrapperStatic
                    openModal={openModal}
                    prices={prices}
                    currencyAttributes={currencyAttributes}
                    isPlccPriceOnPDP={isPlccPriceOnPDP}
                    plccOfferPercentage={plccOfferPercentage}
                  />
                )}
              {shouldRenderPriceOnly && <div id="product-price-promo-content-placeholder" />}
            </>
          )}
        </div>
      )}
    </>
  );
};

Product.propTypes = {
  currencySymbol: PropTypes.string.isRequired,
  priceCurrency: PropTypes.string.isRequired,
  selectedColorProductId: PropTypes.string.isRequired,

  isCanada: PropTypes.bool.isRequired,
  isHasPlcc: PropTypes.bool.isRequired,
  isGiftCard: PropTypes.bool.isRequired,
  currencyAttributes: PropTypes.shape({}).isRequired,

  /* We are available to know if is an international shipping */
  isInternationalShipping: PropTypes.bool.isRequired,
  productDetails: PropTypes.shape({}).isRequired,
  formValues: PropTypes.shape({}).isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  onAddItemToFavorites: PropTypes.func.isRequired,
  isShowPriceRangeKillSwitch: PropTypes.bool.isRequired,
  isMatchingFamily: PropTypes.bool.isRequired,
  isBundleProduct: PropTypes.bool,
  keepAlive: PropTypes.bool,
  reviewOnTop: PropTypes.bool.isRequired,
  AddToFavoriteErrorMsg: PropTypes.string,
  removeAddToFavoritesErrorMsg: PropTypes.func,
  isLoading: PropTypes.bool.isRequired,
  hideItemProp: PropTypes.bool,
  isInWishList: PropTypes.bool.isRequired,
  // currencySign: PropTypes.string,
  showPriceRangeForABTest: PropTypes.bool.isRequired,
  resetCountUpdate: PropTypes.func.isRequired,
  socialProofMessage: PropTypes.string,
  countUpdated: false,
  hidePriceDisplay: PropTypes.bool,
  productObj: PropTypes.shape({}),
  selectedMultipack: PropTypes.string,
  isPerUnitPriceEnabled: PropTypes.bool,
  isStyleWith: PropTypes.bool,
  checkForOOSForVariant: PropTypes.bool.isRequired,
  isBrierleyPromoEnabled: PropTypes.bool,
  TCPStyleQTY: PropTypes.string,
  onSetLastDeletedItemIdAction: PropTypes.func,
  wishList: PropTypes.shape({}),
  deleteFavItemInProgressFlag: PropTypes.bool,
  isAfterPayDisplay: PropTypes.bool,
  isOutfitPage: PropTypes.bool,
  errorMessages: PropTypes.shape({}),
  isShowBrandNameEnabled: PropTypes.bool,
  openModal: PropTypes.func,
  handleRatingClick: PropTypes.func,
  setProductDataForReviewActn: PropTypes.func,
  isNewPDPEnabled: PropTypes.bool,
  primaryBrand: PropTypes.string,
  alternateBrand: PropTypes.string,
  isNewPJPPDPRedesignEnabled: PropTypes.bool,
  setPdpTabSectionName: PropTypes.func,
};

Product.defaultProps = {
  productObj: {},
  isBundleProduct: false,
  hideItemProp: false,
  keepAlive: false,
  AddToFavoriteErrorMsg: '',
  removeAddToFavoritesErrorMsg: () => {},
  socialProofMessage: '',
  // currencySign: '',
  countUpdated: false,
  hidePriceDisplay: false,
  selectedMultipack: '1',
  isPerUnitPriceEnabled: false,
  isStyleWith: false,
  isBrierleyPromoEnabled: false,
  TCPStyleQTY: '',
  onSetLastDeletedItemIdAction: () => {},
  wishList: {},
  deleteFavItemInProgressFlag: false,
  isAfterPayDisplay: false,
  isOutfitPage: false,
  errorMessages: {},
  isShowBrandNameEnabled: false,
  openModal: () => {},
  handleRatingClick: () => {},
  setProductDataForReviewActn: () => {},
  isNewPDPEnabled: false,
  primaryBrand: false,
  alternateBrand: false,
  isNewPJPPDPRedesignEnabled: false,
  setPdpTabSectionName: () => {},
};

export default errorBoundary(Product);
